import * as Yup from 'yup';

// NOTE: this Yup schema must stay in sync with the Zod `UsageRecordSchema`
// in `../schemas/index.ts` and with the field names rendered in
// `./FormComponent.tsx`. FNP-35 fixed a drift where this schema required
// phantom fields (customerId, meterId, meterValue, dimensions) that the
// form never rendered, silently blocking every submit. FNP-58 tracks
// unifying validation on Zod to make this drift structurally impossible.

export const RecordSchema = Yup.object()
                               .shape({
                                          username: Yup.string()
                                                       .required('Required'),
                                          usageType: Yup.string()
                                                        .required('Required'),
                                          value: Yup.number()
                                                    .required('Required'),
                                          action: Yup.string()
                                                     .required('Required'),
                                          recordId: Yup.string()
                                                       .required('Required'),
                                          created: Yup.string()
                                                      .required('Required'),
                                      });
